import { takeLatest } from 'redux-saga/effects';
import { put } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { fetchQueueDetail } from '../api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processQueueDetail(action: any) {
  const queues = action.data.items;
  for (const q of queues) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const queue = yield fetchQueueDetail({ id: q._id });
    yield put({ type: AT.FETCH_QUEUE_DETAIL_DONE, ...queue });
  }
}

export default function* queueDetailSaga() {
  yield takeLatest(AT.FETCH_QUEUES_DONE, processQueueDetail);
}
